'use strict';

var DistanceUnitService = function DistanceUnitService(configurationService) {
  /**
   * Available units
   * @type {{KM: string, MILES: string, : string}}
   */
  var distanceUnits = {
    'KM': 'K',
    'MILES': 'M',
    '': 'd'
  };

  /**
   * Removes last char and adds current unit suffix
   * @param {string} string
   * @returns {string}
   */
  function applySuffix(string) {
    return string.slice(0, -1) + getSuffix();
  }

  /**
   * Returns suffix, depending on the HEP settings
   * @returns {string}
   */
  function getSuffix() {
    var distanceUnit = configurationService.getDistanceUnit();
    return distanceUnits[distanceUnit];
  }
  return {
    applySuffix: applySuffix,
    getSuffix: getSuffix
  };
};
DistanceUnitService.$inject = ['ConfigurationService'];
module.exports = DistanceUnitService;